<template>
  <div class="responsive_menu" :class="open ? 'open' : ''" style="display:block;overflow:hidden">
    <ul class="main_menu">
      <template v-for="(item,index) in items">
        <li v-if="!item.children && item.name" :class="active == item.name ? 'active' : ''" :key="index">
          <router-link :to="{name: item.name}">{{item.label[lang]}}</router-link>
        </li>
        <li v-else-if="item.children" 
          :class="active == item.name || item.children.map(i => i.name).includes(active) ? 'active' : ''" 
          :key="index">
          <a href="#" v-if="!item.name">{{item.label[lang]}}</a>
          <router-link v-else :to="{name: item.name}">{{item.label[lang]}}</router-link>
          <ul>
            <template v-for="(children,index) in item.children">
              <li v-if="children.name" :class="active == children.name ? 'active' : ''" :key="index">
                <router-link :to="{name: children.name}">{{children.label[lang]}}</router-link>
              </li>
            </template>
          </ul>
        </li>
      </template>

      <ul class="list-lenguage">
        <li class="lenguage lenguage-left" :class="langResponsive == 'en' ? 'active' : ''">
          <a href="#"  @click.prevent="langResponsive = 'en'">EN</a>
        </li>
        <li class="lenguage lenguage-middle active"><span class="divider">|</span></li>
        <li class="lenguage lenguage-right" :class="langResponsive == 'es' ? 'active' : ''">
          <a href="#"  @click.prevent="langResponsive = 'es'">ES</a>
        </li>
      </ul>
    </ul>
  </div> <!-- /.responsive_menu -->
</template>

<script>
// @ is an alias to /src

export default {
  name: 'header-responsive',
  props: ['active', 'lang', 'items', 'open'],
  data() {
    return {
      langResponsive: this.lang
    }
  },
  watch: {
    langResponsive() {
      this.$emit('changeLang',this.langResponsive)
    },
    lang() {
      this.langResponsive = this.lang
    }
  }
}
</script>

<style scoped>
  /* Enter and leave animations can use different */
  /* durations and timing functions.              */
  .slide-toggle-enter-active {
    transform: translateY(100%);
    transition: height .5s ease;
  }
  .slide-toggle-leave-active {
    transition: height .3ms ease;
  }
  .slide-toggle-enter, .slide-toggle-leave-to
  /* .slide-fade-leave-active below version 2.1.8 */ {
    transform: translateY(-100%);
  }
</style>
